import { LookupState } from '../states';

const state: LookupState = {
  general: {},
  region: undefined,
  sector: undefined,
  trade: undefined,
  lossOfUsePremiums: undefined,
  wording: {},
  interestedParty: undefined,
};
export default state;
